<div
    #HorizontalScrollerContainer
    [@scroll]="{ value: animationState, params: { scrollAmount: translateXPosition, duration: duration } }"
    (@scroll.start)="animationStart($event)"
    (@scroll.done)="animationDone($event)"
    (touchstart)="onTouchStart($event)"
    (touchend)="onTouchEnd($event)"
    class="horizontal-container">
    <ng-content></ng-content>
</div>

